import { sortBy } from "lodash-es";
import { defineStore } from "pinia";
import { computed, ref } from "vue";

import type { ServerTime, TimerEvent } from "@/model/timer";
import { asReadonly } from "@/utils/vue";

import { useArtStore } from "./art";
import { useBoardStore } from "./board";
import { toggleFunc } from "./helpers/toggle";

export const useTimerStore = defineStore("timer", () => {
  const timers = ref<TimerEvent[]>([]);
  const active = ref(false);

  return {
    active: asReadonly(active),

    boardTimers: computed(() => timers.value.filter(isBoard)),
    artTimers: computed(() => timers.value.filter(isArt)),

    setTimers: (events: TimerEvent[]) => (timers.value = events),
    toggle: toggleFunc(active),
    lowestRunningTimer: (now: ServerTime) => {
      const running = timers.value.filter(
        (timer) =>
          timer.data.state === "running" &&
          timer.data.end >= now &&
          (isBoard(timer) || isArt(timer)),
      );
      return sortBy(running, (timer) => timer.data.end)[0];
    },
  };
});

function isBoard(timer: TimerEvent) {
  return timer.boardId && timer.boardId === useBoardStore().board?.id;
}

function isArt(timer: TimerEvent) {
  return !timer.boardId && useArtStore().isCurrentArt(timer.artId);
}
